'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _WithRouter = _interopRequireDefault(require("Components/WithRouter"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _BackHeader = _interopRequireDefault(require("Components/Navigation/BackHeader"));
var _UserMenu = _interopRequireDefault(require("Components/Navigation/UserMenu"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const {
  app,
  qwest
} = window;
class Back extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      is_sidebar_open: true
    });
    (0, _defineProperty2.default)(this, "pendingMouseDownEvents", []);
    (0, _defineProperty2.default)(this, "toggleSideBar", e => {
      const component = this,
        props = this.props,
        state = this.state;
      localStorage.setItem('is_sidebar_open', !state.is_sidebar_open);
      component.setState({
        is_sidebar_open: !state.is_sidebar_open
      });
    });
    (0, _defineProperty2.default)(this, "logout", () => {
      const component = this,
        props = this.props,
        state = this.state;
      qwest.post('/logout').then(function (xhr, response) {
        // Update user permissions now that user is disconnected
        app.emit({
          event: 'logout',
          source: 'Header',
          data: {
            update_routes: true,
            then: function () {
              props.navigate((0, _Routing.URL)('Login'));
            }
          }
        });
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
    (0, _defineProperty2.default)(this, "captureClick", e => {
      const component = this,
        props = this.props,
        state = this.state;
      const pending_count = component.pendingMouseDownEvents.length;
      const pendingMouseDown = component.pendingMouseDownEvents[pending_count - 1];
      const down_was_fired = typeof pendingMouseDown === 'function';
      if (down_was_fired) {
        pendingMouseDown();
        component.pendingMouseDownEvents.pop();
      }
      app.emit({
        event: 'documentClick',
        source: 'Layout',
        data: {
          e,
          down_was_fired: down_was_fired
        }
      });
    });
    (0, _defineProperty2.default)(this, "captureMouseDown", e => {
      const component = this,
        props = this.props,
        state = this.state;
      e.persist();
      const callback = () => {
        app.emit({
          event: 'documentMouseDown',
          source: 'Layout',
          data: {
            e
          }
        });
      };
      component.pendingMouseDownEvents.push(callback);
    });
    (0, _defineProperty2.default)(this, "captureMouseUp", e => {
      const component = this,
        props = this.props,
        state = this.state;
      app.emit({
        event: 'documentMouseUp',
        source: 'Layout',
        data: {
          e
        }
      });
    });
    (0, _defineProperty2.default)(this, "render", () => {
      const component = this,
        props = this.props,
        state = this.state;
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "back-page",
        onClick: component.captureClick,
        onMouseDown: component.captureMouseDown,
        onMouseUp: component.captureMouseUp
      }, /*#__PURE__*/_react.default.createElement("header", {
        className: "o-header o-header--back"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "o-header__left"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "o-header__logo-container"
      }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
        className: "o-header__logo"
      })), props.page_title ? /*#__PURE__*/_react.default.createElement("h1", {
        className: "o-header__page-title"
      }, props.page_title) : undefined), /*#__PURE__*/_react.default.createElement(_BackHeader.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "o-header__right"
      }, /*#__PURE__*/_react.default.createElement(_UserMenu.default, {
        toggleHotelSelection: component.toggleHotelSelection,
        requestLogout: component.logout
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-content"
      }, props.children));
      return output;
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      is_sidebar_open: localStorage.getItem('is_sidebar_open') === 'true'
    });
  }
}
var _default = exports.default = (0, _WithRouter.default)(Back);
